//
import { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'

//
import global from 'common'

import { Permissions } from 'core/application/account/permissions'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import ChangePassword from '../../account/changePassword'
import { LOGIN_PATH } from '../../account/login/Login'
import EmployeeDashboardWrapper, { MenuItem } from '../common/EmployeeDashboardWrapper'
import Dashboard from '../perks/home'
import MyProfilePerks from './employeeProfile'
import PerksSubmitExpense from './submitExpense'

const PerksEmployeeDashboard = () => {
  const history = useHistory()
  const [user] = global.hooks.useLoginUser()

  useEffect(() => {
    if (!user.permissions.includes(Permissions.AccessEligibleEmployeeDashboard)) history.push(LOGIN_PATH)
  }, [])

  return (
    <EmployeeDashboardWrapper navigationMenu={navigationMenu}>
      <Switch>
        <Route
          key={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_PROFILE}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_PROFILE}
          component={MyProfilePerks}
        />
        <Route
          key={NavigationMapping.ChangePassword}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_CHANGE_PASSWORD}
          component={ChangePassword}
        />
        <Route
          key={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SUBMIT_EXPENSE}
          path={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SUBMIT_EXPENSE}
          component={PerksSubmitExpense}
        />
        {navigationMenu
          .sort((first, second) => second.key - first.key)
          .map((item: MenuItem) => (
            <Route key={item.key} path={item.path} component={item.component} />
          ))}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </EmployeeDashboardWrapper>
  )
}

export default PerksEmployeeDashboard

enum NavigationMapping {
  Dashboard = 1,
  LegalDocuments = 2,
  MyProfile = 3,
  ChangePassword = 4,
}

const navigationMenu: MenuItem[] = [
  {
    name: 'menu.dashboard',
    key: NavigationMapping.Dashboard,
    path: ROUTE_PATHS.ELIGIBLE_EMPLOYEE_DASHBOARD,
    icon: 'dashboard',
    component: Dashboard,
  },
]
